<template>
	<div>
		<Header />
		<div class="imgHead">
			<img src="../../assets/1.png" alt="">
		</div>
		<div class="banner_container" v-show="showbanner">
			<el-carousel :interval="5000" trigger="click" ref="carousel" autoplay @mouseenter.native="autoplayHandler">
				<el-carousel-item v-for="(item, index) in bannerImageLi" :key="index">
					<img :src="item.br_pic" :style="{ objectFit: 'cover' }" alt="" :class="['i' + index]" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="banner_container" v-show="showbannerPhone">
			<el-carousel :interval="5000" trigger="click" ref="carousel" autoplay @mouseenter.native="autoplayHandler">
				<el-carousel-item v-for="(item, index) in bannerImageLi1" :key="index">
					<img :src="item.sc_value" :style="{ objectFit: 'cover' }" alt="" :class="['i' + index]" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- <div class="video" v-show="showVideo">
			<video id="example_video_2" type="video/mp4" class="video-js vjs-default-skin" loop controls metadata autoplay
				:src="videoContent" style="width: 100%;height:98.5%;" data-setup="{}">
			</video>
		</div> -->
		<!-- <div style="" v-show="showdonghua" class="animation_jkx">
			<img src="./三文建筑｜3andwich-Design.png" alt="" style="margin-top:39px" class="donghua">
		</div> -->
		<Footer />
	</div>
</template>
<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import Title from '../../components/Title.vue'
import Axios from 'axios'
import videojs from 'video.js'
import Vue from 'vue'
export default {
	components: {
		Header,
		Footer,
		Title,
	},
	data() {
		return {
			performance: '',
			timer: null,
			videoContent: '',
			flag: true,
			showdonghua: true,
			showbanner: true,
			showVideo: false,
			showbannerPhone:false,
			bannerImageLi: [],
			bannerImageLi1:[],
			ref: 0,
		}
	},
	created() {

	},
	mounted() {
		if (window.sessionStorage.getItem('ABD_DATA')) {
			var abd_Data = window.sessionStorage.getItem('ABD_DATA');
			var dataOne = JSON.parse(abd_Data)
			for (var i = 0; i < dataOne.rows.length; i++) {
				if (dataOne.rows[i].sc_value == '轮播图'&& document.body.clientWidth > 750) {
					Axios({
						url: '/apiv4/getBresourceList?brCategory=首页轮播',
						data: {},
						method: 'GET',
					}).then((res) => {
						this.bannerImageLi = res.data.data.rows
						this.showVideo = false;
						this.showbanner = true;
						this.showbannerPhone=false
					})
				}else if (document.body.clientWidth < 750) {
					for(var i=0;i<dataOne.rows.length;i++){
						if(dataOne.rows[i].sc_key.indexOf('PHONE_BANNER')!=-1){
							this.bannerImageLi1.push(dataOne.rows[i])
						}
					}
					this.showVideo = false;
					this.showbanner = false;
					this.showbannerPhone=true
				}

			}
		} else {
			Axios({
				url: '/apiv4/getSconfigList',
				data: {},
				method: 'GET',
			}).then((res) => {
					if (document.body.clientWidth > 750) {
						Axios({
							url: '/apiv4/getBresourceList?brCategory=首页轮播',
							data: {},
							method: 'GET',
						}).then((res) => {
							this.bannerImageLi = res.data.data.rows
							this.showVideo = false;
							this.showbanner = true;
							this.showbannerPhone=false;
						})
					}else{ 
						for(var i=0;i<res.data.data.rows.length;i++){
								if(res.data.data.rows[i].sc_key.indexOf('PHONE_BANNER')!=-1){
									this.bannerImageLi1.push(res.data.data.rows[i])
								}
							}
						this.showVideo = false;
						this.showbanner = false;
						this.showbannerPhone=true
				}
			
			})
		}
		Vue.config.errorHandler = (err, vm, info) => {
			console.log(err);
		}
		var lanuage = window.sessionStorage.getItem('chinese')
		if (!lanuage) {
			lanuage = 'CN'
		}
		// if (lanuage == 'CN') {
		// 	this.showVideo = false;
		// 	this.showbanner = true;
		// }
		// if (lanuage == 'EN') {
		// 	this.showVideo = true;
		// 	this.showbanner = false;
		// }
	},
	methods: {
		autoplayHandler() {
			this.$refs.carousel.handleMouseEnter = () => { }
		},
		initVideo() {
			//初始化视频方法
			// this.$video(example_video_2, {
			// //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
			// controls: true,
			// //自动播放属性,muted:静音播放
			// autoplay: false,
			// //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
			// preload: "auto",
			// //设置视频播放器的显示宽度（以像素为单位）
			// //width: "90%",
			// //自适应容器
			// fluid: true,
			// //设置视频播放器的显示高度（以像素为单位）
			// //是否重新播放
			// loop: true
			// });
		}
	},
}
</script>

<style lang="scss">
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';

	.video-js {
		background-color: #2e2b36 !important;
	}
    .imgHead{
		position: absolute;top:45px;left:0px;width:450px;z-index:8
	}
	.animation_jkx {
		position: absolute;
		z-index: 99999;
		width: 600px;
		height: 100px;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		background: #fff;
		text-align: center;
		animation: jkx 0s ease-in 4s forwards;
	}

	video {
		overflow: hidden;
		object-fit: cover;
	}

	video:focus {
		outline: none;
	}

	.video {
		width: 99.1vw;
		height: 100vh;
		overflow: hidden !important;
	}

	.donghua {
		width: 300px;
		height: 22px;
		animation-name: scaleDraw;
		/*关键帧名称*/

		animation-timing-function: linear;
		/*动画的速度曲线*/

		animation-iteration-count: 1;
		/*动画播放的次数*/

		animation-duration: 4s;
		/*动画所花费的时间*/
	}

	@keyframes scaleDraw {

		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			transform: scale(1);
			/*开始为原始大小*/
		}

		20% {
			transform: scale(1.4);
			/*放大1.1倍*/
		}

		50% {
			transform: scale(1);
		}

		75% {
			transform: scale(1);
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes jkx {

		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			opacity: 1;
			/*开始为原始大小*/
		}

		100% {
			width: 0;
			height: 0;
			opacity: 0;
		}
	}

	.el-carousel__item:nth-child(1) {
		img {
			opacity: 0;
		}

	}

	.dis_flex {
		text-align: center;
	}

	.banner_container {
		.el-carousel__button {
			width: 15px !important;
			height: 15px !important;
			border-radius: 50% !important;
		}

		.el-carousel__arrow i {
			font-size: 60px !important;
			color: #e3dbdb;
			cursor: pointer !important;
		}

		.el-carousel__arrow {
			width: 60px !important;
			height: 60px !important;
			background: rgba(0, 0, 0, 0) !important;
		}

		.el-icon-arrow-left {
			width: 60px !important;
			height: 60px !important;
		}

		.el-carousel {
			margin: 0 0 20px;

			.el-carousel__container {
				height: 100vh;
			}

			.el-carousel__item img {
				width: 100%;
				height: 100%;
				cursor: pointer;
			}
		}
	}

	.news_container_x {
		.el-carousel__button {
			width: 10px !important;
			height: 10px !important;
			border-radius: 50% !important;
		}
	}

	.company_introduction_x {
		.el-carousel__button {
			height: 35px !important;
		}
	}

	.news_container_x,
	.company_introduction_x {
		.el-carousel {
			height: 415px;

			.el-carousel__container {
				height: 100%;
			}

			.el-carousel__item img {
				width: 100%;
				height: 100%;
			}
		}
	}
}

.el-carousel__indicators--labels .el-carousel__indicator {
	padding: 4px 40px !important;
}

@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m_index.scss';
	.imgHead{
		position: absolute;top:45px;left:0px;width:100% !important;z-index:8;
	}
	.imgHead>img{
		width: 100%;
	}
	video {
		overflow: hidden;
		object-fit: cover;
	}

	video:focus {
		outline: none;
	}

	.video {
		width: 100vw;
		height: 100vh;
		overflow: hidden !important;
	}

	.animation_jkx {
		position: absolute;
		z-index: 99999;
		width: 350px;
		height: 100px;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		background: #fff;
		text-align: center;
		animation: jkx 0s ease-in 4s forwards;
	}

	.donghua {
		width: 300px;
		height: 22px;
		animation-name: scaleDraw;
		/*关键帧名称*/

		animation-timing-function: linear;
		/*动画的速度曲线*/

		animation-iteration-count: 1;
		/*动画播放的次数*/

		animation-duration: 4s;
		/*动画所花费的时间*/
	}

	@keyframes scaleDraw {

		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			transform: scale(1);
			/*开始为原始大小*/
		}

		20% {
			transform: scale(1.4);
			/*放大1.1倍*/
		}

		50% {
			transform: scale(1);
		}

		75% {
			transform: scale(1);
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes jkx {

		/*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
		0% {
			opacity: 1;
			/*开始为原始大小*/
		}

		100% {
			width: 0;
			height: 0;
			opacity: 0;
		}
	}

	::v-deep .banner_container {
		width: 15px !important;
		height: 15px !important;
		border-radius: 50% !important;
	}

	::v-deep .el-carousel__button {
		width: 0px !important;
		height: 0px !important;
		border-radius: 50% !important;
	}

	.banner_container {
		// padding: 0 rm(20);
		padding-bottom: rm(15);

		.banner_container {
			width: 15px !important;
			height: 15px !important;
			border-radius: 50% !important;
		}

		.el-carousel__button {
			display: none !important;
			width: 0px !important;
			height: 0px !important;
			border-radius: 50% !important;
		}

		.el-carousel__arrow i {
			font-size: 40px !important;
			color: #e3dbdb;
			cursor: pointer !important;
		}

		.el-carousel__arrow {
			width: 40px !important;
			height: 40px !important;
			background: rgba(0, 0, 0, 0) !important;
			display: block !important;
		}

		.el-icon-arrow-left {
			width: 40px !important;
			height: 40px !important;
		}

		.el-carousel__button {
			width: 15px !important;
			height: 15px !important;
			border-radius: 50% !important;
		}

		.el-carousel {
			// margin: rm(10) 0 rm(30);

			.el-carousel__container {
				height: 100vh;
			}

			.el-carousel__item img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.news_container_x {
		.el-carousel__button {
			width: rm(10) !important;
			height: rm(10) !important;
			border-radius: 50% !important;
		}
	}

	.company_introduction_x {
		.el-carousel__button {
			height: rm(35) !important;
		}
	}

	.news_container_x,
	.company_introduction_x {
		.el-carousel {
			height: rm(240);
			margin-bottom: rm(20);

			.el-carousel__container {
				height: 100%;
			}

			.el-carousel__item img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
}
</style>